import type { SlideProps } from "@/engine/app/offsite-config";

const REGELN = [
  {
    title: "Quelle verlangen",
    text: "„Woher weißt du das?“ — kann die KI keine Quelle nennen, gilt die Aussage als Behauptung.",
  },
  {
    title: "Fakten selbst prüfen",
    text: "Paragrafen, Fristen, Preise: einmal im Original gegenlesen, bevor es zum Kunden geht.",
  },
  {
    title: "Wissen mitgeben",
    text: "Die KI kennt unsere Prozesse nicht — Vorgaben, Fristen und Beispiele gehören in den Prompt.",
  },
];

export function Slide07bHalluzination(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Vorsicht, überzeugend falsch</div>
        <h1 className="deck-title rise rise-2">
          So sieht eine <br />
          <span className="accent">Halluzination aus</span>
        </h1>
      </header>

      <div className="ki-sort-quote rise rise-3" style={{ marginBottom: 20 }}>
        <div className="ki-sort-quote-from">Eine KI antwortet — flüssig und falsch:</div>
        <div className="ki-sort-quote-text">
          „Nach <strong>§ 8 Abs. 5 EnWG</strong> muss der Netzbetreiber
          Einspeiseanfragen <strong>binnen 14 Tagen</strong> beantworten,
          sonst gilt die Reservierung automatisch als erteilt.“
        </div>
        <div className="ki-sort-quote-tags">
          <span className="ki-sort-tag">Klingt präzise</span>
          <span className="ki-sort-tag">Paragraf: erfunden</span>
          <span className="ki-sort-tag">Frist: erfunden</span>
        </div>
      </div>

      <div className="deck-cols2" style={{ gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }}>
        {REGELN.map((r, i) => (
          <div key={r.title} className={`col-card rise rise-${i + 4}`}>
            <div className="col-eyebrow">Regel 0{i + 1}</div>
            <h4>{r.title}</h4>
            <p>{r.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
